<template>
  <div class="wrap personal-wrap flex-column">
    <div class="flex-item">
      <div class="user-info">
        <!-- <img class="user-hear" src="/static/images/ic_more_3x.png"> -->
        <imgs class="user-hear" :imagePath="listMemDetailInfo.avatarImage&&listMemDetailInfo.avatarImage.imagePath"></imgs>
        <div tag="div" class="user-info-text" @click="openUserInfo">
          <p>{{listMemDetailInfo.nickName}}</p>
          <mu-chip class="demo-chip" :disable="true">
            {{listMemDetailInfo.mobile}}
          </mu-chip>
        </div>
        <img class="user-right" src="/static/images/ic_more_3x.png">
        <!-- {{listMemDetailInfo.}} -->
        <div class="user-grid">
          <mu-row gutter>
            <!--  <mu-col width="33" tablet="33" desktop="33">
             <p class="red" @click="openMyAccount"><span class="user-grid-money">{{listMemAccountMsg.balance||0.0}}</span>元</p>
             <p>我的账户</p>
           </mu-col> -->
            <mu-col width="33" tablet="33" desktop="33">
              <p class="red" @click="openMyCoupon"><span class="user-grid-money">{{listMemAccountMsg.couponNum||0}}</span>张</p>
              <p>我的优惠券</p>
            </mu-col>
            <mu-col width="33" tablet="33" desktop="33">
              <p class="red" @click="openMyRedpack"><span class="user-grid-money">{{listMemAccountMsg.redpacketNum||0}}</span>个</p>
              <p>我的红包</p>
            </mu-col>
          </mu-row>
        </div>
      </div>
      <div class="user-order">
        <div class="user-order-title" @click="openMyOrders(1)">
          <p>我的订单<span class="right">查看全部订单</span></p>
          <img class="user-right" src="/static/images/ic_more_3x.png">
        </div>
        <div class="order-grid">
          <mu-row gutter>
            <mu-col width="25" tablet="25" desktop="25">
              <mu-badge :content="listMemOrderCount.waitPayNum" circle secondary v-bind:badgeClass="[listMemOrderCount.waitPayNum==0 || loading?'none-badge':'custom-badge']">
                <div @click="openMyOrders(2)">
                  <img src="/static/images/personal/orders_unpaid_3x.png">
                  <p>待支付</p>
                </div>
              </mu-badge>
            </mu-col>
            <mu-col width="25" tablet="25" desktop="25">
              <mu-badge :content="listMemOrderCount.payedNum" circle secondary v-bind:badgeClass="[listMemOrderCount.payedNum==0 || loading ?'none-badge':'custom-badge']">
                <div @click="openMyOrders(3)">
                  <img src="/static/images/personal/orders_unrecieved_3x.png">
                  <p>支付成功</p>
                </div>
              </mu-badge>
            </mu-col>
            <mu-col width="25" tablet="25" desktop="25">
              <mu-badge :content="listMemOrderCount.productNum" circle secondary v-bind:badgeClass="[listMemOrderCount.productNum==0 || loading ?'none-badge':'custom-badge']">
                <div @click="openMyOrders(4)">
                  <img src="/static/images/personal/orders_unestimate_3x.png">
                  <p>生产中</p>
                </div>
              </mu-badge>
            </mu-col>
            <mu-col width="25" tablet="25" desktop="25">
              <mu-badge :content="listMemOrderCount.shippedNum" circle secondary v-bind:badgeClass="[listMemOrderCount.shippedNum==0|| loading ?  'none-badge':'custom-badge']">
                <div @click="openMyOrders(5)">
                  <img src="/static/images/personal/orders_uncollected_3x.png">
                  <p>已发货</p>
                </div>
              </mu-badge>
            </mu-col>
          </mu-row>
        </div>
      </div>
      <div class="user-order">
        <div class="user-order-title">
          <p>必备工具</p>
          <!-- <img class="user-right" src="/static/images/ic_more_3x.png"> -->
        </div>
        <div class="order-grid">
          <mu-row gutter>
            <mu-col width="25" tablet="25" desktop="25">
              <div @click="openMyCollection">
                <img src="/static/images/personal/personal_collect_3x.png">
                <p>我的收藏</p>
              </div>
            </mu-col>
            <mu-col width="25" tablet="25" desktop="25">
              <div @click="openMyComments">
                <img src="/static/images/personal/personal_estimate_3x.png">
                <p>我的评价</p>
              </div>
            </mu-col>
            <mu-col width="25" tablet="25" desktop="25">
              <div @click="openInvoiceInfo">
                <img src="/static/images/personal/personal_invoice_3x.png">
                <p>发票信息</p>
              </div>
            </mu-col>
            <mu-col width="25" tablet="25" desktop="25">
              <div @click="openAddress">
                <img src="/static/images/personal/personal_shipping_address_3x.png">
                <p>收货地址</p>
              </div>
            </mu-col>
          </mu-row>
        </div>
      </div>
      
    </div>
    <div class="tripartite-box" @click="loginOut">
        <span class="wxauth-title">
          退出登录
        </span>
    </div>
    <menus></menus>
    <mu-toast v-if="toast.isShow" :message="toast.messageTip" class="custom-toast" />
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import { mapActions, mapGetters } from 'vuex';
import imgs from '@components/image/image';
import { storage } from "@common/utils/util.js";
export default {
  data() {
    return {
      loading:true,
      listMemDetailInfo: [], //获取会员详细信息
      listMemAccountMsg: [], //获取账户信息
      listMemOrderCount: [], //获取会员订单数量
      toast:{
            isShow:false,
            messageTip:'',
      }
    }
  },
  methods: {
    ...mapActions({
      getMemDetailInfo: 'getMemDetailInfo', //获取会员详细信息
      getMemAccountMsg: 'getMemAccountMsg', //获取账户信息
      getMemOrderCount: 'getMemOrderCount', //获取会员订单数
      logout: 'logout',//退出登录
      doLogout:'doLogout',//执行退出登录
    }),
    showTipMessage(isShow,msg){
        this.toast.isShow = isShow;
        this.toast.messageTip =msg;
        setTimeout(() => { 
          this.toast.isShow = false 
        }, 1500);
    },
    loginOut(){
      this.logout().then(res=>{
        // alert(JSON.stringify(res))
        this.doLogout().then(res=>{
          this.showTipMessage(true,'退出成功');
          storage.local.remove('userInfo');
          storage.local.remove('invoiceData') 
          setTimeout(() => { 
            this.$router.push({ path: '/' })
          }, 500);
          
        })
        
      }).catch(err =>{
         this.showTipMessage(true,err || '退出失败');
      })
    },
    //打开个人信息页面
    openUserInfo() {
      this.$router.push({
        path: '/main/userinfo'
      })
    },
    //打开我的订单页面
    openMyOrders(type) {
      this.$router.push({
        path: '/main/myorders?type=' + type
      })
    },
    //打开我的账户
    openMyAccount() {
      this.$router.push({
        path: '/main/myaccount'
      })
    },
    //打开我的红包
    openMyRedpack() {
      this.$router.push({
        path: '/main/myredpack'
      })
    },
    //我的优惠券
    openMyCoupon() {
      this.$router.push({
        path: '/main/mycoupon'
      })
    },
    //打开收货地址
    openAddress() {
      this.$router.push({
        path: '/main/myaddress'
      })
    },
    //打开发票信息
    openInvoiceInfo() {
      this.$router.push({
        path: '/main/invoiceinfo'
      })
    },
    //打开我的评论
    openMyComments() {
      this.$router.push({
        path: '/main/mycomments'
      })
    },
    openMyCollection() {
      this.$router.push({
        path: '/main/mycollection'
      })
    }
  },
  watch: {},
  created() {
    //获取会员信息
    this.getMemDetailInfo().then(res => {
      this.listMemDetailInfo = res;
    });
    //获取账户信息
    this.getMemAccountMsg().then(res => {
      this.listMemAccountMsg = res.target;
    });
    this.getMemOrderCount().then(res => {
      this.listMemOrderCount = res;
      this.loading = false;
    })
  },
  components: {
    menus,
    imgs
  }
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';
.personal-wrap{
  .tripartite-box{
    text-align: center;
    margin:0.5rem 0.35rem;
    margin-top: 1rem;
    .wxauth-title{
        color: #999;
        @include font-dpr(14px);
        padding: 0 3rem;
        position: relative;
        &:before,&:after{
          content: "";
          display: inline-block;
          width: 2.5rem;
          height: 1px;
          position: absolute;
          top: 50%;
          background: #E5E5E5;
        }
        &:before{
          left: 0;
        }
        &:after{
          right: 0;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// personal.vue?673dc6fc